import React, { Component } from 'react';
import { Table, Button, } from 'semantic-ui-react';
import { serverIp, toCurrency, pythonApiIp, } from '../../../../config/constants.js'
import axios from 'axios'
import PayItemRow from './PayItemRow.js';
import PayItemGroup from './PayItemGroup'
import * as UiConsts from '../../../../config/UiConstants';

function ShowExpenseAccounts(props) {

    const rows = props.expenseAccounts.length > 0
        ? props.expenseAccounts.map((item) =>
            <Table.Row>
                <Table.Cell> {item.accountName} </Table.Cell>
                <Table.Cell>{toCurrency(item.balance)}</Table.Cell>
            </Table.Row>)
        : ''

    return (
        <div>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Account</Table.HeaderCell>
                        <Table.HeaderCell>Amount</Table.HeaderCell>

                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {rows}
                </Table.Body>

            </Table>
        </div>
    )
}


class ViewUnPaidDaily extends Component {
    constructor(props) {
        super(props);
        this.state = {
            unpaidList: [],
            beyonicBalance: 0,
            itemArray: [],
            unpaidExpenseTotal: '',
            expenseAccounts:[]
        }
    }


    componentDidMount() {
        console.log("++++++++:componentDidMount");
        this.getUnpaidList();
    }

    getUnpaidList = () => {
        console.log("++++++++:getUnpaidList");
        console.log("new state item array:" + JSON.stringify(this.state.itemArray));
        console.log("date:" + this.state.dateNum);

        this.setState({ loading: true, });

        axios.post(serverIp + 'billing/getUnPaidDailyExpense', {
            apiKey: "ad#4fsdUUddf",
            adminEmail: "testemail"
        })
            .then((response) => {
                console.log("dud1:"+JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    this.setState({
                        loading: false,
                        unpaidList: response.data.unpaidList,
                        beyonicBalance: response.data.beyonicBalance,
                        itemArray: response.data.itemArray,
                        unpaidExpenseTotal: response.data.unpaidExpenseTotal,
                        expenseAccounts:response.data.expenseAccounts
                    });


                } else {
                    this.setState({ loading: false });
                    alert(response.data.message);
                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }

    makePayment = (item) => {
        console.log("++++++++:makePayment");
        console.log("item:" + JSON.stringify(item, null, 3));
        this.setState({ loading: true });

        axios.post(serverIp + 'billing/markStockItemPaid', {
            apiKey: "ad#4fsdUUddf",
            adminEmail: "testemail",
            iditemsBoughtDetail: item.iditemsBoughtDetail
        })
            .then((response) => {
                this.setState({ loading: false });
                console.log(JSON.stringify(response.data.unpaidList, null, 3));

                if (response.data.result) {
                    this.getUnpaidList();
                    this.setState({
                        loading: false,
                    });

                    alert(response.data.message);

                } else {
                    this.setState({ loading: false });
                    alert(response.data.message);
                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

   

    render() {

        const itemTotals = this.state.itemArray.length > 0
            ? this.state.itemArray.map((item) => <div><h5>{item.itemCode} - {toCurrency(item.itemTotal)} 
            <PayItemGroup item={item} user={this.props.user} getUnpaidList={this.getUnpaidList} /> </h5><br/></div>)
            : ''


        const rows = this.state.unpaidList.length > 0
            ? this.state.unpaidList.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.daDate} </Table.Cell>
                    <Table.Cell> {item.iditemsBoughtDetail} </Table.Cell>
                    <Table.Cell>{item.item}</Table.Cell>
                    <Table.Cell>{toCurrency(item.totalPrice)}</Table.Cell>
                    <Table.Cell><PayItemRow makePayment={this.makePayment} item={item} /></Table.Cell>

                    {/* <Table.Cell><Button color='red'>PAY</Button></Table.Cell> */}
                </Table.Row>)
            : ''



        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            <h4> CURRENT TOTALS </h4>
            <h5>TOTAL UNPAID BALANCE: {toCurrency(this.state.unpaidExpenseTotal)}</h5>
            {itemTotals}
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>ID</Table.HeaderCell>
                        <Table.HeaderCell>Item</Table.HeaderCell>
                        <Table.HeaderCell>Amount</Table.HeaderCell>
                        <Table.HeaderCell>Pay</Table.HeaderCell>

                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {rows}
                </Table.Body>

            </Table>
            <h1>Current Beyonic Balance:{new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'UGX' }).format(this.state.beyonicBalance)}</h1>
            <ShowExpenseAccounts expenseAccounts={this.state.expenseAccounts} />
        </div>);
    }
}

export default ViewUnPaidDaily;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/ViewUnpaidDaily.js